import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=a36d4c6c&scoped=true"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"
import style0 from "./Modify.vue?vue&type=style&index=0&id=a36d4c6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36d4c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36d4c6c')) {
      api.createRecord('a36d4c6c', component.options)
    } else {
      api.reload('a36d4c6c', component.options)
    }
    module.hot.accept("./Modify.vue?vue&type=template&id=a36d4c6c&scoped=true", function () {
      api.rerender('a36d4c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/Modify.vue"
export default component.exports